// extracted by mini-css-extract-plugin
export default {"wrapper":"OtpInput_wrapper__cmH3x","typing":"OtpInput_typing__vNzGh","verifying":"OtpInput_verifying__cwnKq","verified":"OtpInput_verified__MQVZO","error":"OtpInput_error__nWYOw"};